import { Component, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { DownloadComponent } from 'src/app/shared/components/download/download.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { DownloadService } from 'src/app/shared/services/download.service';
import { Store } from '@ngrx/store';
import { DatasetActions, DatasetSelectors } from 'src/app/store';
import { MatAccordion, MatExpansionPanel } from '@angular/material/expansion';
import { Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatListOption, MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { ActivatedRoute, Router } from "@angular/router";
import { ExportService } from 'src/app/shared/services/export.service';
import { expand } from 'rxjs/operators';

declare var $$: any;


@Component({
    selector: 'app-datasets',
    templateUrl: './datasets.component.html',
    styleUrls: ['./datasets.component.scss'],
})


export class DatasetsComponent implements OnInit, OnDestroy {
    @ViewChild(MatAccordion) accordion: MatAccordion;
    @ViewChild(MatSelectionList) sampleTypeList: MatSelectionList;
    @ViewChildren(MatExpansionPanel, {}) expansionPanels: QueryList<MatExpansionPanel>;
    @ViewChild(CdkConnectedOverlay) overlay: CdkConnectedOverlay;

    vm$ = this.store.select(DatasetSelectors.selectDatasetsVM);
    private _datasets: any[] = [];
    loadedDatasets: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    private _datasetsSubscribtion: Subscription;
    private _loadedCount: number = 10;
    isSampleTypeFilterOpen: boolean = false;
    sampleTypeSelectedOptions = [];
    previousSampleTypeSelectedOptions = [];
    show: boolean = false;
    enablechkNetCdf: boolean = false;
    isMeasurementMode: boolean = false;
    listOfNetCdfFileName: string[];



    displayedColumns = ['expander', 'displayText', 'publicationYear', 'zoteroUrl', 'sampleTypes', 'download'];

    errorMessage: any;
    filterValues: any = {
        areaId: null,
        bioGroup: null,
        bodyPar: null,
        cacheKey: null,
        lastUpdate: null,
        nuclideId: null,
        reference: null,
        reset: false,
        sampleTypeId: 0,
        samplingDepthFrom: null,
        samplingDepthTo: null,
        samplingYear: null,
        search: true,
        sedimentType: null,
        shapeTypeId: 1,
        subAreaId: null,
        downloadFileType: null,
        isFromUrl: false
    };
    selectedRefId: number = 0;
    showDialog = false;
    activeComponent: any;
    sampleTypes: any[] = [1, 2, 3, 4];

    get showCollapseButton() {
        return this.expansionPanels?.map((x) => x).every((panel) => panel.expanded) || false;
    }

    get disableLoadMore() {
        return this._loadedCount >= this._datasets.length;
    }

    constructor(private exportService: ExportService, private dialogService: DialogService, private downloadService: DownloadService, private store: Store, private route: ActivatedRoute, private router: Router,) {

        this.route.params.subscribe((params) => {
            if (params['refId']) {
                var str = params['refId'];
                var splitted = str.split(".");
                var selValue = "";
                var reid = 0;

                if (splitted != null) {

                    reid = splitted[0];

                    if (splitted[1] == "csv") {
                        selValue = "downCsv";
                    }
                    else if (splitted[1] == "nc") {
                        selValue = "downNetCdf";
                    }

                }
                this.downLoadnamesChange(selValue, reid)
            }
        });
    }

    getEpanelExpanded(id: number) {
        const panel = this.getEpanel(id);
        return panel?.expanded;
    }

    toggleEpanelId(id: number) {
        const panel = this.getEpanel(id);
        panel.toggle();
    }

    private getEpanel(id: number) {
        const headerId = document.getElementById(`ep-${id}`)?.getElementsByTagName('mat-expansion-panel-header')[0].id;
        const panel = this.expansionPanels?.find((panel) => panel._headerId === headerId);
        return panel;
    }

    ngOnInit(): void {

        this.getNetCDFFilelist().then((data) => {
            this.listOfNetCdfFileName = data;
        });

        this.store.dispatch(
            DatasetActions.setFilter({
                filterValue: null,
                sampleTypes: this.sampleTypeSelectedOptions,
            })
        );
        this.dialogService.activeComponent().subscribe((activeComponent) => {
            if (!activeComponent) {
                this.closeDialog();
            }
            this.activeComponent = activeComponent;
        });

        this._datasetsSubscribtion = this.store.select(DatasetSelectors.selectDatasetsVM).subscribe((data) => {
            this._datasets = data.datasets;
            this._loadedCount = 10;
            this.loadedDatasets.data = data.datasets.slice(0, this._loadedCount);
        });

    }

    ngOnDestroy(): void {
        this._datasetsSubscribtion.unsubscribe();
    }

    async getNetCDFFilelist(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.exportService.getnetcdffilelistfromserver().subscribe((data) => {
                resolve(data);
            });
        });
    }

    getNetCDFFilelist1() {

        //this.exportService.getnetcdffilelistfromserver().subscribe((data) => {
        //    this.listOfNetCdfFileName = data;
        //});

        //this.getnetcdffilelistfromserve().then((data) => {
        //    this.listOfNetCdfFileName = data;
        //});

        this.exportService.getnetcdffilelistfromserver()
            .subscribe((result: any) => {
                this.listOfNetCdfFileName = result;
            });
    }

    selectAllSampleTypes() {
        // if option 'all' is selected, then unselect all options otherwise select all options
        if (this.sampleTypeSelectedOptions.find((option) => option == 'all')) {
            this.sampleTypeList.selectAll();
        } else {
            this.sampleTypeList.deselectAll();
        }
    }

    onSortChange(event: { active: any; direction: any; }) {
        this.store.dispatch(
            DatasetActions.setSampleTypesSort({
                filterSortColumn: event.active,
                filterSortDirection: event.direction,
            })
        );
    }

    sampleTypeSelectionChange(change: any[]) {
        // if any option is unselected, then unselect 'all' option
        if (change.find((option) => option == 'all') && this.previousSampleTypeSelectedOptions.find((option) => option == 'all') && change.length < 5 && change.length > 1) {
            this.sampleTypeSelectedOptions = change.filter((option) => option != 'all');
        }

        this.previousSampleTypeSelectedOptions = this.sampleTypeSelectedOptions;

        this.store.dispatch(
            DatasetActions.setSampleTypesFilter({
                sampleTypes: this.sampleTypeSelectedOptions,
            })
        );
    }

    @HostListener('click', ['$event'])
    public handleClick(event: { target: { id: string; }; }) {
        if (event.target.id == 'container') {
            this.openDialog();
        }
    }

    @HostListener('document:keydown', ['$event'])
    onKeyDownHandler(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.closeDialog();
        }
    }

    splitSampleTypes(sampleTypes: string) {
        if (sampleTypes) {
            return sampleTypes.split(',');
        } else {
            return [];
        }
    }

    filter(searchValue: any) {
        this.store.dispatch(
            DatasetActions.setFilter({
                filterValue: searchValue.target.value,
                sampleTypes: this.sampleTypeSelectedOptions,
            })
        );
    }

    toggleSampleTypeFilter() {
        this.isSampleTypeFilterOpen = !this.isSampleTypeFilterOpen;
    }

    sampleTypeLabel(id: number) {
        if (id == 1) {
            return 'Seawater';
        }
        if (id == 2) {
            return 'Biota';
        }
        if (id == 3) {
            return 'Sediment';
        }
        if (id == 4) {
            return 'Suspended matter';
        }
    }
    showNetCDFbutton(refId: string) {

        let fname = refId + ".nc";
        if (this.listOfNetCdfFileName != null && this.listOfNetCdfFileName.length > 0) {
            if (this.listOfNetCdfFileName.includes(fname)) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    sampleTypeImage(id: any) {
        return `/assets/icons/svg/st${id}_icon.svg`;
    }

    parseSampleTypes(sampleTypes: string) {
        if (sampleTypes) {
            return sampleTypes.split(',');
        } else {
            return [];
        }
    }

    downLoadnamesChange(selectedValue: string, refId?: any) {
        if (selectedValue == "downCsv") {
            this.filterValues.reference = refId.toString();
            this.filterValues.downloadFileType = "downCsv";
            this.filterValues.isFromUrl = true;
            this.downloadService.setFilterValue(this.filterValues);
            this.enablechkNetCdf = true;
            //this.showDialog = !this.showDialog;
            // this.dialogService.displayComponent(DownloadComponent);

            this.exportService
                .exportSamplescsv(this.filterValues, this.isMeasurementMode)
                .toPromise()
                .then((result: any) => {
                    this.showcsvFile(
                        result,
                        this.filterValues.reference.toString() + ".csv"
                    );
                });

        }
        if (selectedValue == "downNetCdf") {
            this.filterValues.reference = refId.toString();
            this.filterValues.downloadFileType = "downNetCdf";
            this.filterValues.isFromUrl = true;
            this.downloadService.setFilterValue(this.filterValues);
            this.enablechkNetCdf = true;
            // this.showDialog = !this.showDialog;
            //this.dialogService.displayComponent(DownloadComponent);

            this.exportService
                .exportSamplesnetcdf(this.filterValues, this.isMeasurementMode)
                .toPromise()
                .then((result: any) => {
                    this.shownetcdfFile(
                        result,
                        this.filterValues.reference.toString() + ".nc"
                    );
                });

        }

    }

    openDialog(refId?: any) {
        this.filterValues.reference = refId.toString();
        this.filterValues.downloadFileType = "downCsv";
        this.filterValues.isFromUrl = false;
        this.downloadService.setFilterValue(this.filterValues);
        this.enablechkNetCdf = true;

        // this.showDialog = !this.showDialog;
        //this.dialogService.displayComponent(DownloadComponent);

        //CSV file downloaded from database as per client request we have again implement old functionality.
        if (refId != null && refId>0) {
            this.exportService
                .exportSamplesfromdataset(this.filterValues, this.isMeasurementMode)
                .toPromise()
                .then((result: any) => {
                    this.showcsvFile(
                        result,
                        this.filterValues.reference.toString() + ".csv"
                    );
                });
        }
        else {

            this.exportService
                .exportSamples(this.filterValues, this.isMeasurementMode)
                .toPromise()
                .then((result: any) => {
                    this.showcsvFile(
                        result,
                        this.filterValues.reference.toString() + ".csv"
                    );
                });
        }

    }

    openNETCDFDialog(refId?: any) {
        this.filterValues.reference = refId.toString();
        this.filterValues.downloadFileType = "downNetCdf";
        this.downloadService.setFilterValue(this.filterValues);
        this.enablechkNetCdf = true;

        //  this.showDialog = !this.showDialog;
        // this.dialogService.displayComponent(DownloadComponent);


        this.exportService
            .exportSamplesnetcdf(this.filterValues, this.isMeasurementMode)
            .toPromise()
            .then((result: any) => {
                this.shownetcdfFile(
                    result,
                    this.filterValues.reference.toString() + ".nc"
                );
            });



    }
    private shownetcdfFile(blob: any, filename: string) {
        let newBlob = new Blob([blob], { type: 'text/nc' });
        this.show = false;

        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(newBlob, filename);
            return;
        }

        let data = window.URL.createObjectURL(newBlob);
        let link = document.createElement('a');
        link.href = data;
        link.download = filename;
        link.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(data);
            // this.router.navigate(["/datasets"]);
        }, 100);
    }

    private showcsvFile(blob: any, filename: string) {
        let newBlob = new Blob([blob], { type: 'text/csv' });
        this.show = false;

        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(newBlob, filename);
            return;
        }

        let data = window.URL.createObjectURL(newBlob);
        let link = document.createElement('a');
        link.href = data;
        link.download = filename;
        link.click();

        setTimeout(() => {
            window.URL.revokeObjectURL(data);
            // this.router.navigate(["/datasets"]);
        }, 100);
    }

    closeDialog() {
        this.showDialog = false;
    }

    loadMoreDatasets() {
        this._loadedCount += 10;
        this.loadedDatasets.data = this._datasets.slice(0, this._loadedCount);
    }

    overlayOutsideClick(event: any) {
        this.isSampleTypeFilterOpen = false;
    }
}
